import { Auth, API } from "aws-amplify";
import { ICrewsNonFlyingAssignment } from "@vmosolutions/oc-interfaces";

export const getNonFlyingAssignments = async (
  startTime: number,
  endTime: number
): Promise<ICrewsNonFlyingAssignment[]> => {
  const userSession = await Auth.currentSession();
  const token = userSession.getIdToken().getJwtToken();

  const nonFlyingAssignments: ICrewsNonFlyingAssignment[] = await API.get(
    "skytrains",
    `/nfassign?startTime=${startTime}&endTime=${endTime}`,
    {
      headers: {
        Accept: "*/*",
        Authorization: token,
      },
    }
  );

  return nonFlyingAssignments;
};

export const removeNFAFromCrew = async (nfaId: string, crewId: string): Promise<void> => {
  const userSession = await Auth.currentSession();
  const token = userSession.getIdToken().getJwtToken();

  try {
    const response: any = await API.put("skytrains", `/removeCrewMemberFromNFA/${nfaId}`, {
      headers: {
        Accept: "*/*",
        Authorization: token,
      },
      body: {
        crewId,
      },
    });

    // @ts-ignore
    return response;
  } catch (error) {
    // console.error(error);
    return null;
  }
};

export const addNFAToCrew = async (nonFlyingTypeId: string, crewId: string, selectedTime: number): Promise<any> => {
  const userSession = await Auth.currentSession();
  const token = userSession.getIdToken().getJwtToken();

  try {
    const response: any = await API.post("skytrains", "/nfas", {
      headers: {
        Accept: "*/*",
        Authorization: token,
      },
      body: {
        crewId,
        nonFlyingTypeId,
        selectedTime,
      },
    });

    return response;
  } catch (error) {
    console.error(error);
    return null;
  }
};
